import * as S from "components/common/Banner/Overlay.style";

const AchievementsOverlayMobile = () => (
  <S.Overlay>
    <S.TextBanner variant="headline-01" color="white">
      <S.MainInfo>Premiações e reconhecimentos</S.MainInfo>
    </S.TextBanner>
    <S.TextBanner variant="headline-01" color="white">
      <S.SecondaryInfo>Se fazemos bem, a conquista vem</S.SecondaryInfo>
    </S.TextBanner>
    <S.BannerIndicator />
  </S.Overlay>
);
export default AchievementsOverlayMobile;
